


























import { Component, Vue } from 'vue-property-decorator';
import { SchoolViewModel, SchoolService } from '../../api/school';
import { Message } from 'element-ui';
@Component({})
export default class SchoolDetail extends Vue {
  private service: SchoolService = new SchoolService();
  private data: SchoolViewModel = this.service.NewModel;
  private mounted() {
    this.service.GetMySchool().then((response: any) => {
      this.data = response;
    });
  }
  private btnReset_OnClick() {
    this.service.RefreshCode().then((response: any) => {
      this.data.registerCode = response.result;
      this.service.Update(this.data).then((response1: any) => {
        Message.success('重置成功！');
      });
    });
  }
}
